export default __webpack_public_path__ + "static/media/eye-icon.dca5f315.svg";